import { render } from "./ButtonCustom.vue?vue&type=template&id=d3ae54b4&ts=true"
import script from "./ButtonCustom.vue?vue&type=script&lang=ts"
export * from "./ButtonCustom.vue?vue&type=script&lang=ts"

import "./ButtonCustom.vue?vue&type=style&index=0&id=d3ae54b4&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__